"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const CCLibraryIcon=({width:a=24,height:t=24,hidden:e=!1,title:r="CCLibrary"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${t}"
    viewBox="0 0 36 36"
    width="${a}"
    aria-hidden=${e?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path
      d="M33 6h-3V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM4 28V4h24v2H7a1 1 0 0 0-1 1v21Zm28 4H8V8h14v14l4-3 4 3V8h2Z"
    />
  </svg>`;
//# sourceMappingURL=CCLibrary.js.map
